module.exports = require('./helpers/bundle-url').getBundleURL('1g72z') + "logo.c51670a8.svg";